function prepareRating(ratings) {
    const ratingsGroupedByUser = getRatingsGroupedByUser(ratings);
    const ratingsGroupedByAttraction = getRatingsGroupedByAttraction(ratings);
  
    return {
      ratingsGroupedByUser,
      ratingsGroupedByAttraction,
    };
  }
  
  function getRatingsGroupedByUser(ratings) {
    return ratings.reduce((result, value) => {
      
      const { aid, uid, rating } = value;
  
      if (!result[uid]) {
        result[uid] = {};
      }
        
      result[uid][aid] = { rating };
   
      return result;
    }, {});
  }
  
  function getRatingsGroupedByAttraction(ratings) {
    return ratings.reduce((result, value) => {
      const { aid, uid, rating } = value;
      
  
      if (!result[aid]) {
        result[aid] = {};
      }
  
      result[aid][uid] = { rating };
  
      return result;
    }, {});
  }

  // function getRatingsGroupedByAttractionLength(ratings) {
  //   return ratings.reduce((result, value) => {
  //     const { aid, uid, rating } = value;
  
  //     if (!result[aid]) {
  //       result[aid] = {};
  //     }
  
  //     result[aid][uid] = { rating };
  
  //     return result;
  //   }, {});
  // }
  
module.exports = prepareRating;
  